<template>
  <div class="con">
    <Nav />
    <img src="../assets/img/banner2-aboutus.jpg" alt="" class="banner">
    <div class="banner-p">
      <div class="wa">{{ $t("About.bannerT2") }}</div>
      <div class="xian" v-if="$t('language.name') == 'En'"></div>
    </div>
    <div class="title" :style="'font-size:' + $t('About.fs')">
      <img src="../assets/img/ab-top.png" alt="" class="abtop">
      <img src="../assets/img/ab-bot.png" alt="" class="abbot">
      {{ $t("About.h4") }}
    </div>
    <div class="con-box">
      <h4>{{ $t("About.fintech.title") }} &nbsp;/</h4>
      <template v-for="(item, i) in $t('About.fintech.p')">
        <p v-if="typeof item === 'string'" :key="i"> {{ item }}</p>
        <p v-else-if="item.type === 'list'" :key="i">
        <ul>
          <li v-for=" (li, j) in item.value" :key="i - j"> {{ li }} </li>
        </ul>
        </p>
      </template>
      <h4>{{ $t("About.geelyGroup.title") }} &nbsp;/</h4>
      <p v-for="(item, i) in $t('About.geelyGroup.p')" :key="i">{{ item }}</p>
      <!-- <p>{{ $t("About.p3") }}</p>
      <p>{{ $t("About.p4") }}</p>
      <p>{{ $t("About.p9") }}</p>
      <h4>{{ $t("About.t3") }} &nbsp;/</h4>
      <p>{{ $t("About.p5") }}</p>
      <p>{{ $t("About.p6") }}</p>
      <p>{{ $t("About.p7") }}<br>{{ $t("About.p8") }}</p> -->
    </div>
    <div class="w">
      <div class="to">
        <div class="to-in mr40">
          <h4>{{ $t("About.lx") }} &nbsp;/</h4>
          <div class="hz">
            <div class="motia">
              <span @click="checkNav('/contact')">{{ $t("About.xq") }}<i class="iconfont iconLine23"></i></span>
            </div>
            <img src="../assets/img/lx.png" alt="" class="banner2">
          </div>
        </div>
        <div class="to-in">
          <h4>{{ $t("About.lx2") }} &nbsp;/</h4>
          <div class="hz">
            <div class="motia">
              <span @click="checkNav('/join')">{{ $t("About.xq") }}<i class="iconfont iconLine23"></i></span>
            </div>
            <img src="../assets/img/jr.png" alt="" class="banner2">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from './nav'
import Bus from '../assets/js/bus'
export default {
  name: 'About',
  components: {
    Nav,
  },
  created() {
    console.log(localStorage.getItem('languageSet'), 21)
  },
  methods: {
    checkNav(url) {
      if (this.$route.path != url) {
        Bus.$emit("nav", url);
        this.$router.push(url)
        document.body.scrollTop = 0
        // firefox
        document.documentElement.scrollTop = 0
        // safari
        window.pageYOffset = 0
      }
    }
  },
}
</script>

<style scoped lang="less">
.con {
  width: 100%;
  height: 100%;
  background: #F8F8F8;
  min-width: 1260px;
  position: relative;

  .map1 {
    width: 1000px;
    height: 240px;
    margin: 0 auto;
    margin-top: 20px;
  }

  .banner {
    width: 100%;
    height: 387px;
    display: block;
  }

  .banner-p {
    width: 1260px;
    height: 70px;
    position: absolute;
    top: 158px;
    left: 50%;
    margin-left: -630px;
    padding-left: 80px;
    box-sizing: border-box;
  }

  .wa {
    float: left;
    font-style: normal;
    font-weight: 500;
    font-size: 44px;
    line-height: 70px;
    color: #fff;
  }

  .xian {
    float: left;
    background: #fff;
    width: 90px;
    height: 2px;
    margin-top: 34px;
    margin-left: 50px;
  }

  .title {
    width: 1170px;
    height: 240px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.05);
    margin: 0 auto;
    margin-top: -120px;
    position: relative;
    z-index: 3;
    font-size: 28px;
    color: #3D434D;
    line-height: 47px;
    padding: 73px 180px;
    box-sizing: border-box;
    font-weight: 300;
    padding-left: 192px;

    .abtop {
      width: 43px;
      height: 27px;
      position: absolute;
      top: 51px;
      left: 134px;
    }

    .abbot {
      width: 43px;
      height: 27px;
      position: absolute;
      bottom: 51px;
      right: 134px;
    }
  }

  .con-box {
    width: 960px;
    margin: 0 auto;
    padding-bottom: 80px;

    h4 {
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      color: #242A32;
      margin-top: 80px;
    }

    p {
      font-size: 14px;
      line-height: 30px;
      text-align: justify;
      color: #3D434D;
      margin-top: 30px;
    }
  }

  .w {
    width: 100%;
    background: #fff;

    .to {
      width: 960px;
      background: #fff;
      margin: 0 auto;
      padding-bottom: 80px;
      overflow: hidden;

      .to-in {
        width: 460px;
        float: left;
        overflow: hidden;

        h4 {
          font-weight: 500;
          font-size: 20px;
          color: #242A32;
          margin-top: 80px;
          margin-bottom: 20px;
        }

        .hz {
          width: 460px;
          height: 247px;
          overflow: hidden;
          position: relative;

          .banner2 {
            position: absolute;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
            -moz-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            width: 460px;
            height: 247px;
            cursor: pointer;
          }

          .motia {
            position: absolute;
            z-index: 2;
            top: 0;
            left: 0;
            width: 460px;
            height: 247px;
            background: rgba(13, 28, 66, 0);

            span {
              display: block;
              // width: 120px;
              height: 38px;
              border: 1px solid #FFFFFF;
              box-sizing: border-box;
              padding-left: 20px;
              padding-right: 15px;
              font-size: 14px;
              line-height: 38px;
              color: #FFFFFF;
              opacity: 0;
              position: absolute;
              left: 50%;
              top: 50%;
              -webkit-transform: translate(-50%, -50%);
              -moz-transform: translate(-50%, -50%);
              transform: translate(-50%, -50%);
              cursor: pointer;

              i {
                line-height: 38px;
                font-size: 12px;
                color: #fff;
                margin-left: 2px;
              }
            }

            span:hover {
              background: #fff;
              color: #242A32;

              i {
                color: #242A32;
              }
            }
          }
        }

        .hz:hover {
          .banner2 {
            animation: myfirst .6s linear;
            -moz-animation: myfirst .6s linear;
            /* Firefox */
            -webkit-animation: myfirst .6s linear;
            /* Safari 和 Chrome */
            -o-animation: myfirst .6s linear;
            /* Opera */
            animation-fill-mode: forwards;
          }

          .motia {
            animation: myfirst2 .6s linear;
            -moz-animation: myfirst2 .6s linear;
            /* Firefox */
            -webkit-animation: myfirst2 .6s linear;
            /* Safari 和 Chrome */
            -o-animation: myfirst2 .6s linear;
            /* Opera */
            animation-fill-mode: forwards;
          }

          .Line {
            animation: myfirst3 .6s linear;
            -moz-animation: myfirst3 .6s linear;
            /* Firefox */
            -webkit-animation: myfirst3 .6s linear;
            /* Safari 和 Chrome */
            -o-animation: myfirst3 .6s linear;
            /* Opera */
            animation-fill-mode: forwards;
          }

          span {
            animation: myfirst3 .6s linear;
            -moz-animation: myfirst3 .6s linear;
            /* Firefox */
            -webkit-animation: myfirst3 .6s linear;
            /* Safari 和 Chrome */
            -o-animation: myfirst3 .6s linear;
            /* Opera */
            animation-fill-mode: forwards;
          }
        }

        @keyframes myfirst {
          to {
            width: 552px;
            height: 296px;
          }
        }

        @-webkit-keyframes myfirst

        /* Safari 和 Chrome */
          {
          to {
            width: 552px;
            height: 296px;
          }
        }

        @keyframes myfirst2 {
          to {
            background: rgba(13, 28, 66, 0.6);
          }
        }

        @-webkit-keyframes myfirst2

        /* Safari 和 Chrome */
          {
          to {
            background: rgba(13, 28, 66, 0.6);
          }
        }

        @keyframes myfirst3 {
          to {
            opacity: 1;
          }
        }

        @-webkit-keyframes myfirst3

        /* Safari 和 Chrome */
          {
          to {
            opacity: 1;
          }
        }
      }
    }
  }
}

.mr40 {
  margin-right: 40px;
}
</style>




// WEBPACK FOOTER //
// src/views/about.vue